import app from '../app';

class PaymentFieldsService {

    /*@ngInject*/
    constructor(formlyFieldsService) {
        this.formlyFieldsService = formlyFieldsService;
    }

    getFields() {
        return [
            {
                className: 'payment-wrap',
                fieldGroup: [
                    {
                        className: '',
                        key: 'payment_method',
                        name: 'payment_method',
                        type: 'radio',
                        hideExpression: 'model.payment_method=="COMPLIMENTARY"',
                        templateOptions: {
                            label: "How would you like to pay for this order?",
                            required: 'model.form.payment_method.$touched && model.payment_method=="CREDITCARD"',
                            options: [
                                {
                                    id: 'CREDITCARD',
                                    type: 'Credit Card',
                                    checked: true
                                },
                                {
                                    id: 'EFT',
                                    type: 'EFT',
                                    checked: false,
                                },
                                {
                                    id: 'INSTANTEFT',
                                    type: 'Instant EFT',
                                    checked: false,
                                }
                            ],
                            type: 'radio',
                            value: '',
                            id: 'payment_method',
                            readOnly: false
                        }
                    },
                    {
                        className: 'form-details card-form-details',
                        hideExpression: 'model.payment_method != "CREDITCARD"',
                        fieldGroup: [
                            {
                                className: 'fields-group',
                                fieldGroup: [
                                    {
                                        className: 'row',
                                        fieldGroup: [
                                            {
                                                className: 'col-md-6',
                                                key: 'nameOnCard',
                                                type: 'input',
                                                name: "cardname",
                                                templateOptions: {
                                                    label: "Name on Card",
                                                    required: true,
                                                    type: 'text',
                                                    pattern: "[a-zA-Z\\s]+",
                                                    value: '',
                                                    id: 'nameOnCard',
                                                    readOnly: false
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                className: 'fields-group',
                                fieldGroup: [
                                    {
                                        className: 'row',
                                        fieldGroup: [
                                            {
                                                className: 'col-md-6',
                                                key: 'cardNumber',
                                                name: 'cardnumber',
                                                type: 'input',
                                                templateOptions: {
                                                    type: 'number',
                                                    label: "Card Number",
                                                    required: true,
                                                    pattern: "[0-9]{13,16}",
                                                    maxlength: 16,
                                                    value: '',
                                                    id: 'cardNumber',
                                                    readOnly: false
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                className: 'fields-group',
                                fieldGroup: [
                                    {
                                        className: 'row',
                                        fieldGroup: [
                                            {
                                                className: 'col-md-3',
                                                key: 'verificationNumber',
                                                name: 'cardcvv',
                                                type: 'input',
                                                templateOptions: {
                                                    label: "Verification Number",
                                                    required: true,
                                                    className: 'col-md-4 plr-5',
                                                    type: 'number',
                                                    value: '',
                                                    pattern: "[0-9]{3,4}",
                                                    minlength: 3,
                                                    maxlength: 4,
                                                    id: 'verificationNumber',
                                                    readOnly: false,
                                                    showAdditionalInfo: {
                                                        show: true,
                                                        message: 'The last 3/4 digits on the back of your card'
                                                    },
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                className: 'fields-group',
                                fieldGroup: [
                                    {
                                        className: 'row',
                                        fieldGroup: [
                                            {
                                                className: 'col-md-6 col-sm-12',
                                                fieldGroup: [
                                                    {
                                                        className: 'fields-group',
                                                        fieldGroup: [
                                                            {
                                                                className: 'row',
                                                                fieldGroup: [
                                                                    {
                                                                        className: 'col-md-6',
                                                                        key: 'expiryDate',
                                                                        name: 'cardexpirymonth',
                                                                        type: 'select',
                                                                        templateOptions: {
                                                                            required: true,
                                                                            placeholder: 'MM',
                                                                            className: 'col-md-5 plr-5',
                                                                            label: 'Expiry Date',
                                                                            valueProp: "id",
                                                                            labelProp: "name",
                                                                            options: this.formlyFieldsService.monthOptions,
                                                                            nullable: false,
                                                                            nullableDisplay: 'Month',
                                                                            showAdditionalInfo: {show: false}
                                                                        }
                                                                    },
                                                                    {
                                                                        className: 'col-md-6 hide-label',
                                                                        key: 'expiryYear',
                                                                        name: 'cardexpiryyear',
                                                                        type: 'select',
                                                                        templateOptions: {
                                                                            label: 'Expiry Date Year',
                                                                            required: true,
                                                                            placeholder: 'YYYY',
                                                                            className: 'col-md-12 plr-5',
                                                                            valueProp: "id",
                                                                            labelProp: "name",
                                                                            options: [],
                                                                            nullable: false,
                                                                            nullableDisplay: 'Year',
                                                                            showAdditionalInfo: {show: false}
                                                                        },
                                                                        controller: /*@ngInject*/($scope) => {
                                                                            let currentYear = new Date().getFullYear();
                                                                            while (currentYear < new Date().getFullYear() + 10) {
                                                                                $scope.options.templateOptions.options.push({
                                                                                    id: currentYear,
                                                                                    name: currentYear
                                                                                });
                                                                                currentYear++;
                                                                            }
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
    }
}

app.service("paymentFieldsService", PaymentFieldsService);


// WEBPACK FOOTER //
// ./static/js/app/services/payment-fields.service.js